import { createResource, RouterContext } from 'react-resource-router';

import { ForgeNavigationData } from 'src/types/navigation';
import { urls } from 'src/urls/repositories';
import { authRequest, jsonHeaders } from 'src/utils/fetch';

export const fetchForgeRepositoryNavigationData = async (
  repositoryFullSlug: string
): Promise<ForgeNavigationData | null> => {
  const url = urls.api.internal.forgeMenuItems(repositoryFullSlug);
  const response = await fetch(authRequest(url, { headers: jsonHeaders }));

  if (!response.ok) {
    throw new Error(
      `Error fetching repository forge menu items (${response.status}): ${response.statusText}`
    );
  }

  const {
    menu_items,
    admin_menu_items,
    personal_settings_menu_items,
    workspace_menu_items,
  } = await response.json();

  return {
    forgeMenuItems: menu_items,
    forgeAdminMenuItems: admin_menu_items,
    personalSettingsForgeMenuItems: personal_settings_menu_items,
    workspaceForgeMenuItems: workspace_menu_items,
  };
};

export const forgeRepositoryNavigationResource = createResource({
  type: 'FORGE_REPOSITORY_MENU_ITEMS',
  getKey: ({ match }: RouterContext) => {
    if (match.params.repositoryFullSlug) {
      return `forge-repository-menu-items:${match.params.repositoryFullSlug}`;
    } else {
      return `forge-repository-menu-items:${match.params.repositoryOwner}/${match.params.repositorySlug}`;
    }
  },
  maxAge: 1000 * 60 * 10, // 10 minute
  getData: ({ match }): Promise<ForgeNavigationData | null> => {
    const { repositoryFullSlug, repositoryOwner, repositorySlug } =
      match.params;
    const repoFullSlug =
      repositoryFullSlug ?? `${repositoryOwner}/${repositorySlug}`;

    return fetchForgeRepositoryNavigationData(repoFullSlug);
  },
});
